import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { ConfirmButton, MessageEvent } from '..';

@Component({
  selector: 'alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AlertComponent {
  @Input() class?: string;

  @Input() show: boolean;

  @Input() message?: string;

  @Input() item?: MessageEvent;

  @Input() type: 'info' | 'success' | 'danger' | 'warning';

  @Output() hide: EventEmitter<MessageEvent>;

  constructor() {
    this.show = false;
    this.type = 'info';
    this.hide = new EventEmitter<MessageEvent>();
  }

  public onAction(action: ConfirmButton): void {
    if (action.handler) {
      action.handler();
    }
    this.hide.emit(this.item);
  }

  public onHide(): void {
    const actions = this.actions.filter((action: ConfirmButton) => action.close);
    actions.forEach((action: ConfirmButton) => {
      if (action.handler) {
        action.handler()
      }
    });
    this.hide.emit(this.item);
  }

  public get actions(): ConfirmButton[] {
    return this.item?.data?.buttons || [];
  }
}
